























































































































































import { Component, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
/* api */
import LoginApi from '@/app/model/api/loginApi'
/* module */
import Local from '@/app/module/local'
import Validator from '@/app/module/validator'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'
import CommonClass from '@/app/module/common'

@Component({
  components: {
    CommonHeader,
    ErrorInfo
  }
})
export default class Login extends Vue {
  private email: string = ''
  private password: string = ''
  private errorMessages: any = ''
  private alertTitle: string = ''
  private show400ErrorMessage: boolean = false
  private viewHeight:number = 100

  mounted () {
    this.viewHeight = window.innerHeight
  }

  private async login () {
    /* ログイン処理が成功したらfieldへ遷移、失敗したらアラートを表示 */
    if (this.isLogin()) {
      const bodyData = {
        'mailaddress': this.email,
        'password': this.password
      }

      const result = await LoginApi.doLogin(bodyData)
      if (result.isOk()) {
        this.$router.push('/sp/field').catch(e => {})
        // サービス機能設定値を再取得しローカルストレージにセット
        await CommonClass.setServiceFunctionData('sp')
      } else if (result.getPayload().status_code === '404' ||
                 result.getPayload().status_code === '400') {
        this.alertTitle = 'メールアドレスまたはパスワードが違うため、ログインできませんでした。'
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      } else {
        // 500系もしくはbodyがない場合と、その他
        this.$store.commit('routeState/setErrorFlag', errorFlag.ERROR_FLAG_SERVER)
        this.$router.push(routerPath.PATH_SP_ERROR_PAGE).catch(e => {})
      }
    } else {
      this.alertTitle = ''
      this.show400ErrorMessage = true
      window.scrollTo({ top: 0, behavior: 'auto' })
    }
  }

  private isLogin () {
    const emailFlag = Validator.validateInputEmail('emailErrorMessage', this.email)
    const passwordFlag = Validator.validateInputPassword('passwordErrorMessage', this.password)

    this.errorMessages = Validator.getErrorMessage()

    return emailFlag && passwordFlag
  }
}
